import React from 'react';
import { AlternativeContact } from 'app-types';
import { isEmpty } from 'lodash-es';
import { removeEmptyFromArray } from 'utils/utils';

interface Props {
	alternativeContactList?: AlternativeContact[];
}

const alternativeContactsWrapper = <P extends object>(Component: React.ComponentType<P>) =>
	class AlternativeContactsWrapper extends React.Component<P & Props> {
		render() {
			const { alternativeContactList = [], ...props } = this.props;

			const alternativeContactListWithData = removeEmptyFromArray(alternativeContactList).filter(
				item =>
					item.fullName ||
					item.emailAddress ||
					(item.phoneNumber && item.phoneCodeCountryId)

			);

			if (isEmpty(alternativeContactListWithData)) {
				return null;
			}

			return (
				<Component
					alternativeContactList={alternativeContactListWithData}
					{...(props as P)}
				/>
			);
		}
	};

export default alternativeContactsWrapper;
